module.exports = __webpack_public_path__ + "static/media/8OLA23.d9a45b87.jpg";